<div class="app-ajax-loader" *ngIf="showedLoader" [class.full-width-loader]="ajaxLoaderService.isFullWidth()">
    <ng-progress id="app-ajax-progress" [spinner]="false"></ng-progress>
</div>
